"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSAEMRenditionImageComponent = void 0;
class CSAEMRenditionImageComponent {
    constructor() {
        this.aemRenditionImageAllowedBreakpoints = [320, 480, 620, 768, 992].join(',');
        this.imgAllowedToDisplay = false;
    }
    ngOnChanges() {
        if (!this.imgSrc && !this.imgAlt) {
            this.imgAllowedToDisplay = false;
        }
        else {
            this.imgAllowedToDisplay = true;
            setTimeout(() => {
                var _a;
                if ((_a = this.aemRenditionImage) === null || _a === void 0 ? void 0 : _a.nativeElement) {
                    const s7responsiveImage = 's7responsiveImage';
                    window[s7responsiveImage](this.aemRenditionImage.nativeElement);
                    this.aemRenditionImage.nativeElement.style.display = 'block';
                }
            });
        }
    }
    getDataSource() {
        if (this.getWindowHostName() === 'www.cspire.com') {
            return 'https://images.cspire.com/is/image/cspire/' + this.imgSrc + '?$default-preset$';
        }
        return 'https://images.cspire.com/is/image/cspirestage/' + this.imgSrc + '?$default-preset$';
    }
    getWindowHostName() {
        return window.location.host;
    }
}
exports.CSAEMRenditionImageComponent = CSAEMRenditionImageComponent;
//# sourceMappingURL=aem-rendition-image.component.js.map